'use client';

import { type TimeScalar } from '@bts-web/utils-formatting';
import {
  convertToLocaleDateString,
  timeScalarToDate,
} from '@bts-web/utils-formatting-client';
import { Locale, useClientTranslation } from '@bts-web/utils-lokalise';
import { FC } from 'react';
import { InstantClockDisplayedText } from '../../common/components/InstantClockDisplayedText/InstantClockDisplayedText.use-client';

export type RenderTransactionTimeMode = 'date-only' | 'date-hour';

export const RenderTransactionTime: FC<{
  time: TimeScalar;
  locale: Locale;
  mode: RenderTransactionTimeMode;
}> = ({ time, locale, mode }) => {
  if (mode === 'date-only') {
    return <>{convertToLocaleDateString(time, locale)}</>;
  }

  const { t } = useClientTranslation();

  return (
    <InstantClockDisplayedText>
      {t('tx_details_date_hour', {
        date: convertToLocaleDateString(time, locale),
        time: timeScalarToDate(time).toLocaleTimeString(locale),
      })}
    </InstantClockDisplayedText>
  );
};
